module.exports = __webpack_public_path__ + "img/State=13.4560bd49.svg";